<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>


    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="admin_name"
                         label="添加人"
                         min-width="120"></el-table-column>
        <el-table-column prop="desc"
                         label="描述"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="添加时间"
                         min-width="120"></el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  components: {},
  data () {
    return {
      id: 0,
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (this.$route.params.id) {
        params.id = this.$route.params.id
      }
      params = filter.copyJson(params)
      return request.page('getSatisfactionEmailLogTable', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/satisfaction-email/pages/SatisfactionEmailLogTable.vue